import React from 'react';
import * as Sentry from '@sentry/browser';
import { ErrorPage } from '../ErrorPage';

export class ErrorBoundary extends React.Component {
  /* eslint-disable class-methods-use-this */
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.setState({ error });
    Sentry.captureException(error);
  }

  render() {
    return this.state.hasError ? <ErrorPage navbar error={this.state.error} /> : this.props.children;
  }
}
